<template>
    <v-sheet tile>
        <v-img src="../../public/img/code.jpeg" aspect-ratio="4.1078">
            <v-col>
                <v-row>
                <v-col align="center">
                    <span class="display-1  color-alterno-blanco">
                        <h2>Suscríbete!!</h2> 
                    </span>
                </v-col>
            </v-row>
            <v-col align="center">
                <span class="color-alterno-blanco">
                    Para recibir las noticias mas relevante en tecnologia
                </span>
            </v-col>
            <v-row>
                <v-col cols="3"></v-col>
                <v-col cols="12" align="center" md="6" xl="6" sm="6" xs="6">
                    <v-form ref="form">
                        <v-text-field background-color="grey lighten-1" color="" type="email" label="Correo Electrónico" filled  clearable dense>
                        </v-text-field>
                        <v-btn @click="enviar">
                            <span>
                                Enviar
                            </span>
                        </v-btn>
                    </v-form>
                </v-col>
                <v-col cols="3"></v-col>
            </v-row>
            </v-col>
        </v-img>
    </v-sheet>
</template>

<script>
export default {
    data: () => ({
        correo:""
    }),
    methods: {
        enviar(){
            
        }
    }
}
</script>

<style>
.color-alterno-blanco{
    color: white;
}
</style>